// ----------------------------------------------------------------------
// Human-readable labels for the coded values stored on a Formation.
// Mirrors the label maps used by the admin/center-formations Blade views
// so the public site and the back-office describe the same data the same way.
// ----------------------------------------------------------------------

export const MODALITY_LABELS: Record<string, string> = {
  presentiel: "Présentiel",
  distanciel: "Distanciel",
  elearning: "E-learning",
};

export const METHOD_LABELS: Record<string, string> = {
  expositive: "Méthode expositive",
  demonstrative: "Méthode démonstrative",
  interrogative: "Méthode interrogative",
  active: "Méthode active",
  case_study: "Études de cas",
  roleplay: "Jeux de rôle / Mises en situation",
};

export const EVALUATION_LABELS: Record<string, string> = {
  quiz: "QCM / Quiz",
  practical: "Exercices pratiques",
  project: "Projet / Cas pratique",
  oral: "Évaluation orale",
  continuous: "Évaluation continue",
  satisfaction: "Questionnaire de satisfaction",
};

export const FUNDING_LABELS: Record<string, string> = {
  opco: "OPCO",
  cpf: "CPF",
  entreprise: "Entreprise",
  individuel: "Individuel",
};

export const LEVEL_LABELS: Record<string, string> = {
  beginner: "Débutant",
  intermediate: "Intermédiaire",
  advanced: "Avancé",
};
